export default __webpack_public_path__ + "static/media/results2.d9bdbf0d.png";